import { useState, useEffect, useContext } from 'react'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { navigate } from '@reach/router'
import Peer from 'peerjs'

import { NEW_ROOM, JOIN_ROOM, CLEAR_ROOM } from '../graphql/mutations'
import { GET_NEXT } from '../graphql/queries'
import { UserContext } from '../context/user'

export const usePeer = ({ init, code }) => {
	const { dispatch } = useContext(UserContext)

	const [peer] = useState(new Peer())
	const [id, set_id] = useState('')
	const [ready, set_ready] = useState(false)

	const [new_room, { data: new_data }] = useMutation(NEW_ROOM)
	const [join_room, { data: join_data }] = useMutation(JOIN_ROOM, {
		variables: { id, code },
	})
	const [clear_room] = useMutation(CLEAR_ROOM)

	const { startPolling, stopPolling, data: next_data } = useQuery(GET_NEXT, {
		variables: { code },
	})

	const connect = (id) => {
		dispatch({ type: 'update_remote', payload: { id } })
		dispatch({ type: 'update_status', payload: true })
		navigate('/')
	}

	useEffect(() => {
		peer.on('open', (id) => {
			set_id(id)
			dispatch({ type: 'update_local', payload: { init, id, peer } })
			set_ready(true)
		})
	}, [init, peer, dispatch])

	useEffect(() => {
		if (init && id) {
			new_room({ variables: { code, id } })
			startPolling(500)

			return () => clear_room({ variables: { code } })
		}
	}, [init, code, peer, id, dispatch, new_room, clear_room, startPolling])

	useEffect(() => {
		if (init) {
			if (next_data && next_data.next !== '') {
				stopPolling()
				clear_room({ variables: { code } })
				connect(next_data.next)
			}
		}
	}, [init, code, peer, next_data, stopPolling, clear_room]) // eslint-disable-line

	useEffect(() => {
		if (!init) {
			if (code.length === 4 && join_data && join_data.join_room !== '') {
				connect(join_data.join_room)
			}
		}
	}, [init, code, peer, join_data]) // eslint-disable-line

	return { ready, new_data, join_room }
}
